export enum DownloadVehicleCollectionType {
    RABBITMQ = 1,
}